export const updateCartItemQuantity = (cartItems, index, quantity) => {
  return cartItems.map((item, i) =>
    i === index ? { ...item, quantity } : item
  );
};

export const removeFromCart = (cartItems, indexToRemove) => {
  return cartItems.filter((_, index) => index !== indexToRemove);
};

export const calculateTotalCartPrice = (cartItems) => {
  return cartItems.reduce((acc, item) => acc + item.price * (item.quantity || 1), 0);
};

export const addToCart = (cartItems, product, quantity = 1) => {
  const existing = cartItems.find((item) => item.id === product.id);
  if (existing) {
    return cartItems.map((item) =>
      item.id === product.id
        ? { ...item, quantity: Math.min(quantity, product.stock) }
        : item
    );
  } else {
    return [
      ...cartItems,
      { ...product, quantity: Math.min(quantity, product.stock) || 1 },
    ];
  }
};

export const isService = (item) =>
  Boolean(item && (item.type === "service" || item.service === true));

// Example stub for updateSoldDate
export async function updateSoldDate(id) {
  // Implement your logic here
}